export default __webpack_public_path__ + "static/media/image00040.72ed7d5a.jpeg";